import React, { useState, useEffect } from "react";
import RangeSliderLocation from "../../../../components/common/InputField/RangeSliderLocation";
import LocationAutocomplete from "../../../../components/common/InputField/LocationAutocomplete";
import { Field } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { updatePostData } from "../../../../Redux/Slice/createPostSlice";
import {
  BUSINESS_FORM_ACTION_ROW_BETWEEN_CLASS,
} from "../../shared/businessLayoutSpec";
import {
  AdminHeaderAction,
  AdminLinkAction,
  AdminFormFieldError,
  AdminFormFieldLabelRow,
  AdminDetailFieldLabel,
} from "../../../AdminDashboard/shared/adminUx";

const LocationandPortfolio = ({ setStep, setFieldValue, values, handlePost }) => {
  const dispatch = useDispatch();
  const postData = useSelector((state) => state.createPost);
  const [isUpdating, setIsUpdating] = useState(false);

  const handleNextClick = () => {
    if (values.location && values.range) {
      dispatch(
        updatePostData({
          location: values.location,
          range: values.range,
        })
      );
      setIsUpdating(true);
    }
  };

  useEffect(() => {
    if (isUpdating && postData.location) {
      handlePost();
      setIsUpdating(false);
      setStep(6);
    }
  }, [isUpdating, postData.location]);

  return (
    <>
      <div className="w-full">
        <AdminFormFieldLabelRow
          label="Customers Within"
          tooltip="Set how far from your location the post will be shown."
        />
        <Field name="range">
          {({ field, form }) => (
            <div>
              <RangeSliderLocation
                {...field}
                minimum={1}
                starting={values.range}
                maximum={10}
                units="km"
                values={values.range}
                value={values.range}
                onChange={(e) => setFieldValue("range", e.target.value)}
              />
              {form.errors.range ? (
                <AdminFormFieldError className="mt-2">{form.errors.range}</AdminFormFieldError>
              ) : null}
            </div>
          )}
        </Field>

        <div className="mt-5">
          <Field name="location">
            {({ field, form }) => (
              <div className="space-y-1 w-full min-w-0">
                <AdminDetailFieldLabel htmlFor="location">
                  Location <span className="text-alertred">*</span>
                </AdminDetailFieldLabel>
                <LocationAutocomplete
                  {...field}
                  dashboard
                  onChange={(value) => setFieldValue("location", value)}
                  value={values.location}
                  name="location"
                  className="lg:bg-pastalblue"
                  placeholder="Enter suburb, area, or postcode"
                />
                {form.errors.location ? (
                  <AdminFormFieldError>{form.errors.location}</AdminFormFieldError>
                ) : null}
              </div>
            )}
          </Field>
        </div>
      </div>

      <div className={BUSINESS_FORM_ACTION_ROW_BETWEEN_CLASS}>
        <AdminLinkAction type="button" onClick={() => setStep(4)}>
          Back
        </AdminLinkAction>
        <AdminHeaderAction
          type="button"
          onClick={handleNextClick}
          disabled={!values.location || !values.range}
        >
          Next
        </AdminHeaderAction>
      </div>
    </>
  );
};

export default LocationandPortfolio;
